import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Hero141 from '../components/hero141'
import Features2 from '../components/features2'
import Features51 from '../components/features51'
import Features16 from '../components/features16'
import Features25 from '../components/features25'
import Steps2 from '../components/steps2'
import Team17 from '../components/team17'
import Contact10 from '../components/contact10'
import Footer4 from '../components/footer4'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Signbridge AI</title>
        <meta property="og:title" content="Signbridge AI" />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="home-text100">#home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text101">#about</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text102">#team</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="home-text103">#contact</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="home-text104">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="home-text105">About Us</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="home-text106">Our Team</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="home-text107">Contact</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="home-text108">Learn More</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text109">Contact Us</span>
          </Fragment>
        }
        page1Description={
          <Fragment>
            <span className="home-text110">Welcome to Signbridge AI</span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="home-text111">Learn more about Signbridge AI</span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="home-text112">Meet our talented team members</span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="home-text113">Get in touch with us</span>
          </Fragment>
        }
      ></Navbar8>
      <Hero141
        action1={
          <Fragment>
            <span className="home-text114">Contect us</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text115">Talk to us</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text116" > 
              Signbridge AI is revolutionizing accessibility by breaking
              communication barriers with our cutting-edge AI agent for
              real-time, bi-directional sign language translation. Join us in
              empowering individuals and transforming the way we communicate.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text117" id='home-section'>
              Empowering Communication Through AI Agent
            </span>
          </Fragment>
        }
      ></Hero141>
      <Features2
        sectionTitle={
          <Fragment>
            <span className="home-text118">The Problem</span>
          </Fragment>
        }
        feature1ImageSrc="/problem_1-200h.png"
        feature2ImageSrc="/problem_2-200h.png"
        feature3ImageSrc="/problem_3-200h.png"
        feature4ImageSrc="/problem_4-200h.png"
        feature5ImageSrc="/problem_5-200h.png"
        sectionDescription={
          <Fragment>
            <span className="home-text119">
              Disproportionate tech advancement for the one in need
            </span>
          </Fragment>
        }
        feature1Description={
          <Fragment>
            <span className="home-text120">
              High Cost &amp; Limited Access to Interpreters
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text121">
              Ineffectiveness of Subtitles for Native Signers
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text122">
              Barriers in Real-Time Communication
            </span>
          </Fragment>
        }
        feature4Description={
          <Fragment>
            <span className="home-text123">
              Geographic &amp; Sector Inequality
            </span>
          </Fragment>
        }
        feature5Description={
          <Fragment>
            <span className="home-text124">
              Lack of a Scalable, AI-Driven Solution
            </span>
          </Fragment>
        }
      ></Features2>
      <Features51
        feature1Title={
          <Fragment>
            <span className="home-text125">Scalable &amp; Accessible:</span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text126">
              Seamless conversion from sign language to text/speech and vice
              versa
            </span>
          </Fragment>
        }
        feature2Description1={
          <Fragment>
            <span className="home-text127">
              Real-Time Bidirectional Translation
            </span>
          </Fragment>
        }
        feature1Description={
          <Fragment>
            <span className="home-text128">
              Works via smartphones, integrates with platforms like Zoom and
              Microsoft Teams, and paves the way for future AR/VR and wearable
              solutions
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text129">
              <span>
                Utilizes computer vision, generative AI, and motion synthesis
                for lifelike sign generation
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text132">
              Advanced AI &amp; Virtual Avatars:
            </span>
          </Fragment>
        }
        sectionTitle={
          <Fragment>
            <span className="home-text133">Our Solution</span>
          </Fragment>
        }
        sectionDescription={
          <Fragment>
            <span className="home-text134">
              An end-to-end autonomous AI Sign Language Agent
            </span>
          </Fragment>
        }
        feature2ImageSrc="/solution_1-1400w.png"
        feature3ImageSrc="/solution_2-1400w.png"
        feature1ImageSrc="/solution_3-1400w.png"
        rootClassName="features51root-class-name"
      ></Features51>
      <Features16
        feature3Title={
          <Fragment>
            <span className="home-text135">
              Scalable &amp; Accessible everywhere:
            </span>
          </Fragment>
        }
        feature1Description={
          <Fragment>
            <span className="home-text136">
              Seamless conversion from sign language to text/speech and vice
              versa
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text137" id='about-section'>Our Solution</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text138">
              An end-to-end autonomous AI Sign Language Agent
            </span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text139">
              Advanced AI &amp; Virtual Avatars:
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text140">
              Utilizes computer vision, generative AI, and motion synthesis for
              lifelike sign generation
            </span>
          </Fragment>
        }
        feature1Title={
          <Fragment>
            <span className="home-text141">
              Real-Time Bidirectional Translation:
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text142">
              Works via smartphones, integrates with platforms like Zoom and
              Microsoft Teams, and paves the way for future AR/VR and wearable
              solutions
            </span>
          </Fragment>
        }
        feature1ImageSrc="/solution_1-1400w.png"
        feature2ImageSrc="/solution_2-1400w.png"
        feature3ImageSrc="/solution_3-1400w.png"
      ></Features16>
      <Features25
        feature1Title={
          <Fragment>
            <span className="home-text143">
              Real-time Sign Language Translation
            </span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text144">Empowering Accessibility</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text145">Future VR/AR Solutions</span>
          </Fragment>
        }
        rootClassName="features25root-class-name1"
        feature1Description={
          <Fragment>
            <span className="home-text146">
              Our AI agent provides real-time, bi-directional sign language
              translation, breaking communication barriers instantly.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text147">
              We empower individuals by revolutionizing accessibility through
              our AI-powered solution for sign language translation.
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text148">
              We are committed to building VR/AR solutions in the future to
              enhance the user experience and expand accessibility further.
            </span>
          </Fragment>
        }
      ></Features25>
      <Steps2
        step1Title={
          <Fragment>
            <span className="home-text149">Meet Our Team Members</span>
          </Fragment>
        }
        step2Title={
          <Fragment>
            <span className="home-text150">Partnership Opportunities</span>
          </Fragment>
        }
        step3Title={
          <Fragment>
            <span className="home-text151">Future Development</span>
          </Fragment>
        }
        step4Title={
          <Fragment>
            <span className="home-text152">Our Vision for the Future</span>
          </Fragment>
        }
        step1Description={
          <Fragment>
            <span className="home-text153">
              Get to know the talented individuals behind Signbridge AI who are
              dedicated to revolutionizing accessibility and breaking
              communication barriers.
            </span>
          </Fragment>
        }
        step2Description={
          <Fragment>
            <span className="home-text154">
              We are actively seeking government and enterprise partners who are
              interested in leveraging our AI-powered solution for real-time
              sign language translation.
            </span>
          </Fragment>
        }
        step3Description={
          <Fragment>
            <span className="home-text155">
              Stay tuned for our upcoming VR/AR solutions that will further
              enhance accessibility and communication for individuals using sign
              language.
            </span>
          </Fragment>
        }
        step4Description={
          <Fragment>
            <span className="home-text156">
              <span>
                We envision a future where accessibility is the standard.
              </span>
              <br></br>
              <span>
                Our goal is to become the leading unicorn in AI for
                Accessibility, driving innovation in sign language recognition,
                generation, and beyond—building an inclusive world for all.
              </span>
            </span>
          </Fragment>
        }
      ></Steps2>
      <Team17
        review1={
          <Fragment>
            <span className="home-text160">
              An entrepreneur with extensive data science background and AI
              startup experience, focusing on driving innovative sign language
              translation solutions. The Engineer for sign language recognition.
            </span>
          </Fragment>
        }
        review2={
          <Fragment>
            <span className="home-text161">
            Deaf IT Master's graduate with extensive experience engaging with the 
            Deaf community and expertise in human-computer interaction development. 
            Accessibility & Human-Centered Computing Specialist, Gallaudet University MS.
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text162">
            CFO with expertise from Google, Draper Associates, and Oaklins Internationals
            </span>
          </Fragment>
        }
        review4={
          <Fragment>
            <span className="home-text163">
              A software engineer at AWS with a Master’s from CMU, specializing
              in scalable server development, model optimization, and LLM
              fine-tuning.
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text164" id='team-section'>
              See our team members who build this AI Agent  to help the people
              in need.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text165">Our team</span>
          </Fragment>
        }
        review42={
          <Fragment>
            <span className="home-text166">
              <span>
                A research leader with 12+ years of experience in machine
                learning, UC Berkeley Master’s graduate, specializing in
                advancing sign language recognition.
              </span>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        review43={
          <Fragment>
            <span className="home-text174">
              <span>
                An AI researcher with a PhD from the University of Alberta and
                6+ years of experience in machine learning, specializing in sign
                language recognition.
              </span>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        author1Src="/selfie-200h.jpg"
        author2Src="/yasmeen_holguin.jpg"
        author3Src="/calvin_selfie-200h.jpg"
        author4Src="/dongfang_selfie-200h.jpg"
        author7Src="/jace_selfie-200h.jpg"
        author1Name={
          <Fragment>
            <span className="home-text180">Althrun Sun</span>
          </Fragment>
        }
        author2Name={
          <Fragment>
            <span className="home-text181">Yasmeen Holguin</span>
          </Fragment>
        }
        author3Name={
          <Fragment>
            <span className="home-text182">Calvin Chan</span>
          </Fragment>
        }
        author4Name={
          <Fragment>
            <span className="home-text183">Dongfang Ling</span>
          </Fragment>
        }
        author4Src2="/edwina_selfie-200h.jpg"
        author4Src3="/sara_selfie-200h.jpg"
        author4Name2={
          <Fragment>
            <span className="home-text184">Edwina Gu</span>
          </Fragment>
        }
        author4Name3={
          <Fragment>
            <span className="home-text185">Sara Soltaninejad</span>
          </Fragment>
        }
        rootClassName="testimonial17root-class-name1"
        author1Position={
          <Fragment>
            <span className="home-text186">Founder and CEO</span>
          </Fragment>
        }
        author2Position={
          <Fragment>
            <span className="home-text187">CPO</span>
          </Fragment>
        }
        author3Position={
          <Fragment>
            <span className="home-text188">CFO&amp;COO</span>
          </Fragment>
        }
        author4Position={
          <Fragment>
            <span className="home-text189">AI Software Engineer</span>
          </Fragment>
        }
        author4Position2={
          <Fragment>
            <span className="home-text190">Head of Research</span>
          </Fragment>
        }
        author4Position3={
          <Fragment>
            <span className="home-text191">Applied Scientist</span>
          </Fragment>
        }
      ></Team17>
      <Contact10
        content1={
          <Fragment>
            <span className="home-text192">
              Interested in partnering with us? Reach out to our team for more
              information.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text193">Contact Us</span>
          </Fragment>
        }
        location1={
          <Fragment>
            <span className="home-text194">Signbridge AI Headquarters</span>
          </Fragment>
        }
        location2={
          <Fragment>
            <span className="home-text195">
              Government and Enterprise Partnerships
            </span>
          </Fragment>
        }
        location1Description={
          <Fragment>
            <span className="home-text196">
              3338 Webber Ln, Vancouver, Canada
            </span>
          </Fragment>
        }
        location2Description={
          <Fragment>
            <span className="home-text197">
              For government and enterprise partnership inquiries, please
              contact us.
            </span>
          </Fragment>
        }
      ></Contact10>
      <Footer4
        link1={
          <Fragment>
            <span className="home-text198">About Us</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text199">Our Team</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text200">Contact Us</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="home-text201">Partnerships</span>
          </Fragment>
        }
        logoSrc="/icon%26name-1500h.png"
        termsLink={
          <Fragment>
            <span className="home-text202">Terms of Service</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span className="home-text203">Privacy Policy</span>
          </Fragment>
        }
      ></Footer4>
    </div>
  )
}

export default Home
